const abs = Math.abs;
export default abs;
